import { SCOREBONACCI, DIRECTIONS } from "../constants_v2.js";
import {
  getNeighbor,
  gameCoords2Pixels,
  isDouble,
} from "../game/utils-game_v2.js";
import { zoom } from "../zoom_v2.js";
import { colors } from "../colors_v2.js";
import { identityService } from "../profile/identityService_v2.js";
import { NAME_OF_GAME } from "../constants_v2.js";
import { matchService } from "../matches/matchService_v2.js";
import { statsPop } from "./statsPop_v2.js";
import { eventHub } from "../eventHub_v2.js";
import { generateARRs } from "../game/utils-game_v2.js";
import { iPop } from "../ipop_v2.js";

const render = () => {
  const result = matchService.getCurrentMatch();
  const currentMatch = result.currentMatch;
  const html = `
    <div id="scoreBoardContainer">
      <div id="ARRandP1Container" class="ARRandContainer">
      <div id="p1ARR" class="ARR"></div>
        <div id="scoreplayerOneContainer" class= "scorePlayer scoreplayerOne">
          <div id="scoreplayerOne"></div>
          <div id="aaaaaplayerOne" class="score">${
            typeof currentMatch.p1Score === "undefined"
              ? "0"
              : currentMatch.p1Score
          }</div>
        <!-- scoreplayerOneContainer -->
        </div>
      <!-- ARRandP1Container -->
      </div>
      <div class="nameOfGame"><h1 id="nog"></h1></div>
      <div id="ARRandP2Container" class="ARRandContainer">
        <div id="p2ARR" class="ARR"></div>
        <div id="scoreplayerTwoContainer" class= "scorePlayer scoreplayerTwo">
          <div id="scoreplayerTwo"></div>
          <div id="aaaaaplayerTwo" class="score">${
            typeof currentMatch.p2Score === "undefined"
              ? "0"
              : currentMatch.p2Score
          }</div>
        <!-- scoreplayerOneContainer -->
        </div>
      <!-- ARRandP1Container -->
      </div>
    <!-- scoreBoardContainer -->
    </div>
    `;
  document.getElementById("scoreSection").innerHTML = html;
  const scoreplayerOneContainer = document.getElementById(
    "scoreplayerOneContainer",
  );
  const scoreplayerTwoContainer = document.getElementById(
    "scoreplayerTwoContainer",
  );

  if (result.status === 200) {
    // if there is a current match
    renderScoreContent(currentMatch);
  } else {
    // and if there aint
    renderScoreContentNoMatch();
  }

  document.getElementById("nog").innerText = NAME_OF_GAME;
};

const renderScoreContentNoMatch = () => {
  document.getElementById("scoreplayerOne").textContent =
    "No Match In Progress";
  document.getElementById("scoreplayerTwo").textContent =
    "No Match In Progress";
};

const renderScoreContent = (currentMatch) => {
  const turn = matchService.getTurn().player;
  const id = "score" + turn + "Container";
  let p1Name2Render = "";
  let p2Name2Render = "";
  switch (true) {
    case currentMatch.p1Name === "waiting":
      p1Name2Render = "Waiting for them to join";
      break;
    case currentMatch.p1Name != "waiting":
      p1Name2Render = identityService.parseName(currentMatch.p1Name);
  }

  switch (true) {
    case currentMatch.p2Name === "waiting":
      p2Name2Render = "Waiting for them to join";
      break;
    case currentMatch.p2UserID != "waiting":
      p2Name2Render = identityService.parseName(currentMatch.p2Name);
  }

  document.getElementById("scoreplayerOne").textContent = p1Name2Render;
  document.getElementById("scoreplayerTwo").textContent = p2Name2Render;

  document.getElementById(id).style.backgroundColor = colors.getPlayerColor({
    player: turn,
    property: "piece",
  });
  document.getElementById(id).classList.toggle("shadow");
  renderARR(currentMatch);
};

const renderARR = (currentMatch) => {
  const { p1ARR, p2ARR } = generateARRs({
    match: currentMatch,
    style: "short",
  });
  const p1ARRDiv = document.getElementById("p1ARR");
  const p2ARRDiv = document.getElementById("p2ARR");
  p1ARRDiv.innerHTML = p1ARR;
  p2ARRDiv.innerHTML = p2ARR;
};

const renderARRSplainerShort = (event) => {
  const text = `
  <div class="left">
    These numbers are a count of actions taken:<br>
    <br>
    Adds - Rotates - Removes<br> 
  </div>`;
  iPop.render({
    text,
    event,
  });
};

const calculateP1ScoreContainerBackground = () => {
  const container = document.getElementById("scoreplayerOneContainer");
  switch (matchService.getTurn().player) {
    case "playerOne":
      container.style.backgroundColor = colors.getPlayerColor({
        player: "playerOne",
        property: "piece",
      });

      break;
    case "playerTwo":
      container.style.backgroundColor = colors.getGameColor("background");

      break;
  }
};

const calculateP2ScoreContainerBackground = () => {
  const container = document.getElementById("scoreplayerTwoContainer");
  switch (matchService.getTurn().player) {
    case "playerOne":
      container.style.backgroundColor = colors.getGameColor("background");

      break;
    case "playerTwo":
      container.style.backgroundColor = colors.getPlayerColor({
        player: "playerTwo",
        property: "piece",
      });

      break;
  }
};

const commonBorders = ({ coords, player }) => {
  var commonBorders = 0;
  for (const direction of DIRECTIONS) {
    const neighbor = getNeighbor({ coords, direction });
    if (neighbor.player === player) {
      commonBorders++;
    }
  }
  return commonBorders;
};

const drawOffCenterText = ({ text, piece }) => {
  const canvas = document.getElementById("canvas");
  const ctx = canvas.getContext("2d");
  const canvasCoords = gameCoords2Pixels(piece.coords);
  const hexSide = zoom.getHexSide();
  isDouble(piece.coords)
    ? (ctx.font = "normal " + hexSide * 0.8 + "px Arial, sans-serif")
    : (ctx.font = "normal " + hexSide * 0.4 + "px Arial, sans-serif");
  var approxFontHeight = parseInt(ctx.font);
  ctx.textAlign = "center";
  // ctx.fillStyle = colors.getPlayerColor({
  //   player: piece.player,
  //   property: "hover",
  // });
  ctx.fillStyle = "black";
  let xNudge = 0;
  let yNudge = 0;
  switch (piece.direction) {
    case "up":
      yNudge = hexSide / 4;
      break;
    case "down":
      yNudge = -1 * (hexSide / 4);
      break;
    case "upRight":
      xNudge = -1 * (hexSide / 4);
      yNudge = hexSide / 5;
      break;
    case "upLeft":
      xNudge = hexSide / 4;
      yNudge = hexSide / 5;
      break;
    case "downLeft":
      xNudge = hexSide / 5;
      yNudge = -1 * (hexSide / 8);
      break;
    case "downRight":
      xNudge = -1 * (hexSide / 5);
      yNudge = -1 * (hexSide / 8);
      break;
  }
  ctx.beginPath();
  ctx.fillText(
    text,
    canvasCoords.cx + xNudge,
    canvasCoords.cy + approxFontHeight / 4 + yNudge,
  );
  ctx.stroke();
};

const drawRewindScores = (pieces) => {
  var hexScore = 0;
  var p1Score = 0;
  var p2Score = 0;
  for (const piece of pieces) {
    hexScore = calcHexScore(piece);
    const player = piece.player;
    if (hexScore > 0) {
      drawOffCenterText({ text: hexScore, piece });
      // Was `player = "playerOne"` (assignment to a const), which threw at
      // runtime under Vite 7 and fails the build under Vite 8.
      if (player === "playerOne") {
        p1Score = p1Score + hexScore;
      }
      if (player === "playerTwo") {
        p2Score = p2Score + hexScore;
      }
    } else {
      drawOffCenterText({ text: "", piece });
    }
  }
  return { p1Score, p2Score };
};

const updateScores = (pieces) => {
  // Start from zero and calculate everything from scratch
  const currentMatch = matchService.getCurrentMatch().currentMatch;
  if (currentMatch.p1Name != "waiting") {
    matchService.setScore({
      userID: currentMatch.p1UserID,
      score: 0,
    });
  }
  if (currentMatch.p2Name != "waiting") {
    matchService.setScore({
      userID: currentMatch.p2UserID,
      score: 0,
    });
  }
  var hexScore = 0;

  for (const piece of pieces) {
    hexScore = calcHexScore(piece);
    const player = piece.player;
    const name =
      player === "playerOne" ? currentMatch.p1Name : currentMatch.p2Name;
    if (hexScore > 0) {
      drawOffCenterText({ text: hexScore, piece });
      matchService.setScore({
        userID: identityService.parseUserID(name),
        score: matchService.getScore(name) + hexScore,
      }); //update their total
    }
  }
};

const calcHexScore = (piece) => {
  let hexScore = 0;
  const numCommonBorders = commonBorders({
    coords: piece.coords,
    player: piece.player,
  });
  hexScore = SCOREBONACCI[numCommonBorders];
  if (isDouble(piece.coords)) {
    hexScore = hexScore * 2;
  }
  return hexScore;
};

const handlePointerOverScoreP1 = () => {
  document.getElementById("scoreplayerOneContainer").style.backgroundColor =
    colors.getGameColor("accent");
};

const handlePointerOverScoreP2 = () => {
  document.getElementById("scoreplayerTwoContainer").style.backgroundColor =
    colors.getGameColor("accent");
};

eventHub.registerEvent("click", "scoreplayerOneContainer", statsPop.render);
eventHub.registerEvent("click", "scoreplayerTwoContainer", statsPop.render);
eventHub.registerEvent(
  "pointerover",
  "scoreplayerOneContainer",
  handlePointerOverScoreP1,
);
eventHub.registerEvent(
  "pointerout",
  "scoreplayerOneContainer",
  calculateP1ScoreContainerBackground,
);
eventHub.registerEvent(
  "pointerover",
  "scoreplayerTwoContainer",
  handlePointerOverScoreP2,
);
eventHub.registerEvent(
  "pointerout",
  "scoreplayerTwoContainer",
  calculateP2ScoreContainerBackground,
);

eventHub.registerEvent("click", "p1ARRSplainershort", renderARRSplainerShort);

eventHub.registerEvent("click", "p2ARRSplainershort", renderARRSplainerShort);

export const scoreBoard = {
  render,
  updateScores,
  calcHexScore,
  drawRewindScores,
};
